export default function HeroSection() {
  const scrollToAbout = () => {
    const el = document.querySelector('#about');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToContact = () => {
    const el = document.querySelector('#contact');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="relative w-full min-h-screen flex items-center overflow-hidden bg-[#0a0a0a]">
      {/* Background video */}
      <div className="absolute inset-0">
        <video
          autoPlay
          muted
          loop
          playsInline
          className="w-full h-full object-cover object-center"
        >
          <source
            src="https://storage.readdy-site.link/project_files/5bc8e699-d202-4ec0-adea-cc7d9ecf40c0/ae3cdb8f-d83f-4e21-9a13-427d25be4202_0422.mp4?v=2d0bf8930105cace0ab200411bbb5ec9"
            type="video/mp4"
          />
        </video>
        {/* Dark overlay for text readability */}
        <div className="absolute inset-0 bg-[#0a0a0a]/55" />
        {/* Left fade for text contrast */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#0a0a0a] via-[#0a0a0a]/60 to-transparent" />
        {/* Top & bottom fade to black */}
        <div className="absolute inset-x-0 top-0 h-48 bg-gradient-to-b from-black to-transparent" />
        <div className="absolute inset-x-0 bottom-0 h-48 bg-gradient-to-t from-black to-transparent" />
      </div>

      {/* Grain overlay */}
      <div className="absolute inset-0 opacity-[0.03]" style={{backgroundImage: 'url("data:image/svg+xml,%3Csvg viewBox=\'0 0 256 256\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cfilter id=\'noise\'%3E%3CfeTurbulence type=\'fractalNoise\' baseFrequency=\'0.9\' numOctaves=\'4\' stitchTiles=\'stitch\'/%3E%3C/filter%3E%3Crect width=\'100%25\' height=\'100%25\' filter=\'url(%23noise)\'/%3E%3C/svg%3E")'}} />

      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full py-32">
        <div className="max-w-3xl mx-auto text-center">
          {/* Label */}
          <div className="flex items-center justify-center gap-3 mb-8 animate-fade-in">
            <span className="w-12 h-px bg-white/60" />
            <span className="text-white/60 text-xs font-medium tracking-[0.3em] uppercase">Where Sound Becomes Identity</span>
            <span className="w-12 h-px bg-white/60" />
          </div>

          {/* Main headline */}
          <div className="inline-flex flex-col items-center mb-8 mt-0">
          <h1 className="leading-none mb-0 whitespace-nowrap" style={{fontSize: 'clamp(2.2rem, 5.8vw, 5rem)'}}>
            <span
              className="font-bold text-white"
              style={{
                fontFamily: "'Arial Black', 'Impact', 'Franklin Gothic Medium', sans-serif",
                fontStyle: 'italic',
                letterSpacing: '0.01em',
                textShadow: '2px 2px 8px rgba(0,0,0,0.8), 0 0 20px rgba(0,0,0,0.5)',
              }}
            >
              AceAge-
            </span><span
              className="font-bold"
              style={{
                fontFamily: "'Arial Black', 'Impact', 'Franklin Gothic Medium', sans-serif",
                fontStyle: 'italic',
                letterSpacing: '0.01em',
                color: '#00c2d4',
                textShadow: '2px 2px 12px rgba(0,180,210,0.4), 0 0 30px rgba(0,180,210,0.2)',
              }}
            >
              Music
            </span>
          </h1>

          {/* Divider line + tagline */}
            <div className="w-full h-px bg-white/30 mt-3 mb-2" />
          </div>
          <div className="mb-8 -mt-6">
            <p
              className="text-white/70 tracking-[0.25em] uppercase"
              style={{fontSize: 'clamp(0.55rem, 1.1vw, 0.8rem)', fontFamily: "'Arial', sans-serif", fontWeight: 400}}
            >
              ... We Make A Difference In The World Of Music!
            </p>
          </div>

          <p className="text-white/50 text-base max-w-xl leading-relaxed mb-12 mx-auto">
            Over two decades shaping the electronic music scene through music production, artist development, and label direction.
          </p>

          {/* Stats */}
          <div className="flex items-center justify-center gap-10 mb-12">
            {[
              { value: '20+', label: 'Years Experience' },
              { value: '250+', label: 'Official Releases' },
              { value: '75+', label: 'Key Projects' },
            ].map(stat => (
              <div key={stat.label} className="text-center">
                <div className="text-white font-bold text-3xl" style={{fontFamily: "'Bebas Neue', sans-serif"}}>{stat.value}</div>
                <div className="text-white/40 text-xs tracking-widest uppercase mt-1">{stat.label}</div>
              </div>
            ))}
          </div>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={scrollToContact}
              className="bg-white text-black font-semibold px-8 py-4 rounded-full hover:bg-white/90 transition-all duration-300 text-sm tracking-wide cursor-pointer whitespace-nowrap"
            >
              Work With Us
            </button>
            <button
              onClick={scrollToAbout}
              className="border border-white/30 text-white font-medium px-8 py-4 rounded-full hover:border-white/70 hover:bg-white/5 transition-all duration-300 text-sm tracking-wide cursor-pointer whitespace-nowrap"
            >
              Discover Our Story
            </button>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/30 text-xs tracking-widest uppercase">Scroll</span>
        <div className="w-px h-8 bg-gradient-to-b from-white/30 to-transparent" />
      </div>
    </section>
  );
}
